module.exports = __webpack_public_path__ + "static/img/__8970.12a7cd3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/__8970.jpg
// module id = IwXQ
// module chunks = 0